import styled from 'styled-components'

import Theme from '@theme'

export const ChartContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`

export const ChartTitle = styled.h3`
  font-size: 1rem;
  font-weight: 500;
  color: ${Theme.grey900Color};
  margin: 0 0 1rem;
`

export const SVGContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: visible;

  svg {
    width: 100%;
    height: 100%;
    overflow: hidden;
    cursor: grab;

    &:active {
      cursor: grabbing;
    }
  }
`

export const Tooltip = styled.div`
  position: absolute;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  background-color: ${Theme.grey900Color};
  color: ${Theme.whiteColor};
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1.4;
  box-shadow: 0 2px 8px rgb(0 0 0 / 15%);
  z-index: 1000;
  transition: opacity 0.2s ease, visibility 0.2s ease;
  max-width: 200px;
  word-wrap: break-word;
`

export const ResetButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 4px 12px;
  border: 1px solid ${Theme.grey400Color};
  border-radius: 4px;
  background: ${Theme.whiteColor};
  color: ${Theme.grey700Color};
  font-size: 12px;
  font-family: Rubik, sans-serif;
  cursor: pointer;
  z-index: 10;
  transition: background 0.15s ease, color 0.15s ease;

  &:hover {
    background: ${Theme.grey100Color};
    color: ${Theme.grey900Color};
  }
`
